module.exports = {
  'active': 'aktiv',
  'answered': 'besvaret',
  'approved': 'godkendt',
  'available': 'tilgængelig',
  'characters': 'tegn',
  'chars': 'tegn',
  'completed': 'fuldført',
  'connected': 'forbundet',
  'done': 'færdig',
  'error': 'fejl',
  'failed': 'mislykkedes',
  'installs': 'installationer',
  'loading': 'indlæser',
  'no': 'nej',
  'paused': 'sat på pause',
  'pending': 'afventer',
  'probing': 'undersøger',
  'question': 'spørgsmål',
  'rejected': 'afvist',
  'required': 'påkrævet',
  'running': 'kører',
  'selected': 'valgt',
  'sending': 'sender',
  'sent': 'sendt',
  'stopped': 'stoppet',
  'streaming': 'streamer',
  'success': 'gennemført',
  'thinking': 'tænker',
  'yes': 'ja'
};
